import React, { useEffect, useMemo, useState } from "react";
import styles from "./stateManagement.module.scss";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import { connect, useDispatch } from "react-redux";
import {
  getAllCountries,
  getAllStates,
  createState,
  updateState,
} from "../../store/actions";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const columns = [
  { id: 1, label: "S.NO", minWidth: 120, align: "center" },
  { id: 2, label: "STATE NAME", minWidth: 170, align: "center" },
  //   { id: 3, label: "COUNTRY", minWidth: 170, align: "center" },
  { id: 4, label: "ACTION", minWidth: 120, align: "center" },
];

const StateManagement = ({ states = [], countries = [] }) => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState(null); // holds state object or null
  //   const [form, setForm] = useState({ stateName: "", countryId: "" });
  const [form, setForm] = useState({ stateName: "" });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(getAllStates());
    // dispatch(getAllCountries());
  }, [dispatch]);

  //   const getCountryLabel = (countryId) => {
  //     if (Number(countryId) === 1) return "India";
  //     return String(countryId ?? "-");
  //   };

  const getStructuredRows = (data = []) =>
    data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        item?.name || "-",
        // getCountryLabel(item?.countryId),
        <div
          key={`edit-${item?.id}`}
          className={styles.imgtable}
          onClick={() => handleEditOpen(item)}
        >
          <EditIcon color="primary" />
          EDIT
        </div>,
      ],
    }));
console.log(states,"states")

  const resetForm = () => {
    // setForm({ stateName: "", countryId: "" });
    setForm({ stateName: "" });
    setErrors({});
  };

  const handleAddOpen = () => {
    setEditing(null);
    resetForm();
    setDialogOpen(true);
  };

  const handleEditOpen = (item) => {
    setEditing(item);
    // setForm({ stateName: item?.stateName ?? "", countryId: item?.countryId ?? "" });
    setForm({ stateName: item?.name ?? "" });
    setErrors({});
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const validate = () => {
    const e = {};
    if (!form.stateName?.trim()) e.stateName = "State name is required";
    // if (
    //   form.countryId === "" ||
    //   form.countryId === null ||
    //   form.countryId === undefined
    // )
    //   e.countryId = "Country is required";
    // setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    const payload = {
      name: form.stateName?.trim(),
    //   countryId: Number(form.countryId),
    };
    const callback = {
      success: () => {
        handleClose();
        dispatch(getAllStates());
      },
    };
    if (editing?.id) {
      dispatch(
        updateState({ payload: { ...payload, id: editing.id }, callback })
      );
    } else {
      dispatch(createState({ payload, callback }));
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}>States</div>
          <div className={styles.search}>
            <CustomButton
              title={"Add State"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={handleAddOpen}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable columns={columns} rows={getStructuredRows(states)} />
        </div>
      </div>

      <Dialog open={dialogOpen} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{editing ? "Edit State" : "Add State"}</DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              gap: 16,
              flexDirection: "column",
              paddingTop: 8,
            }}
          >
            <TextField
              label="State Name"
              value={form.stateName}
              onChange={(e) =>
                setForm((p) => ({ ...p, stateName: e.target.value }))
              }
              error={Boolean(errors.stateName)}
              helperText={errors.stateName || ""}
              fullWidth
            />
            {/* <FormControl fullWidth error={Boolean(errors.countryId)}>
              <InputLabel id="country-select-label">Country</InputLabel>
              <Select
                labelId="country-select-label"
                label="Country"
                value={form.countryId}
                onChange={(e) =>
                  setForm((p) => ({ ...p, countryId: e.target.value }))
                }
              >
                {countries?.map((c) => (
                  <MenuItem key={c?.id} value={c?.id}>
                    {c?.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  states: state?.state?.states,
//   countries: state?.country?.countries,
});

export default connect(mapStateToProps, null)(StateManagement);
